import PropTypes from 'prop-types';

const Condition = ({ when, is, children }) => {
  return (
    when === is ?
      children :
      null
  );
};

Condition.propTypes = {
  children: PropTypes.node.isRequired,
  is: PropTypes.string.isRequired,
  when: PropTypes.string.isRequired,
};

export default Condition;
